import { PRODUCTS } from "../../data/siteData";
import ProductCard from "./ProductCard";
import "./Products.css";

function Products({ onNavigate }) {
  return (
    <section className="products">
      <div className="container">
        <p className="products__eyebrow">OUR COLLECTION</p>
        <h2 className="products__heading">Shop Our Formulas</h2>
        <div className="products__grid">
          {PRODUCTS.map((product) => (
            <ProductCard
              product={product}
              onNavigate={onNavigate}
              key={product.id}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;